import axios from 'axios'

export default {
  fetchUserPermissions (data) {
    return axios.get('/api/user/permission', {params: data})
  },
  bulkDeleteUserPermissions (data) {
    return axios.post('/api/user/permission/bulk-delete', data)
  },
  createUserPermission (payload) {
    return axios.post('/api/user/permission', payload)
  },
  detailUserPermission (id) {
    return axios.get('/api/user/permission/'+ id + '/show')
  },
  updateUserPermission (payload) {
    return axios.patch('/api/user/permission/'+ payload.id + '/update', payload)
  },
  deleteUserPermission (id) {
    return axios.delete('/api/user/permission/'+ id + '/destroy')
  },
  fetchLinkedRecords (id) {
    return axios.get('/api/user/'+ id + '/linked-records')
  },
    assignLinkedRecords (payload) {
        return axios.post('/api/user/'+ payload.id + '/reassign', payload)
    },
    assignMultipleLinkedRecords (payload) {
        return axios.post('/api/user/'+ payload.id + '/reassign-multiple', payload)
    },
}
